// extracted by mini-css-extract-plugin
module.exports = {"cartPopover":"cartPopover_cartPopover__pNMF0","container":"cartPopover_container__3lS10","productsRow":"cartPopover_productsRow__1feQZ","buyButton":"cartPopover_buyButton__36qYA"};